const AUTH_FLOW_PATHS = new Set([
    "/signup",
    "/login",
    "/email-verification",
    "/resetPassword",
    "/password-reset",
    "/onboard",
    "/onboard-pricing",
    "/setup-channel",
    "/setup-channel-languages",
    "/setup-channel-languages-add",
    "/setup-branding",
]);

function normalizePathname(pathname: string): string {
    return pathname.split("?")[0].split("#")[0].replace(/\/+$/, "") || "/";
}

/**
 * Auth, password, and onboarding routes where the cookie banner covers the form.
 * Public watch and embed suppression stays in the existing path helpers.
 */
export function isAuthFlowPath(pathname: string | null | undefined): boolean {
    if (!pathname) {
        return false;
    }
    return AUTH_FLOW_PATHS.has(normalizePathname(pathname));
}
